import React, { useState } from 'react'
import styled, { useTheme } from 'styled-components'
import AccordionCard, { AccordionCardRow } from 'core-system/AccordionCard'
import Text from 'core-system/Text'
import Box from '../components/Box'
import { AiInsight } from '../types'

interface AiInsightsProps {
  insights?: AiInsight[]
}

const InsightsHeader = styled.div`
  margin-bottom: 1.5rem;
`

const InsightHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

const InsightContent = styled.div`
  margin: 1rem;
`

const InsightText = styled(Text)`
  font-size: 0.875rem;
  line-height: 1.5;
  color: #333;
  margin: 0;
`

const getInsightColor = (index: number, theme: any): string => {
  const colors = [
    theme.palette.accent.blue500,
    theme.palette.accent.teal500,
    theme.palette.secondary.purple500,
    theme.palette.warning.yellow500,
    theme.palette.primary.pink500,
  ]
  return colors[index % colors.length]
}

const AiInsights: React.FC<AiInsightsProps> = ({ insights }) => {
  const [openStates, setOpenStates] = useState<Record<number, boolean>>({})

  // Handle undefined, null, or empty array
  if (!insights || insights.length === 0) {
    return null
  }

  const handleToggle = (index: number) => {
    setOpenStates((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }

  return (
    <Box style={{ padding: '1.25rem' }}>
      <InsightsHeader>
        <Text variant='h5' marginBottom='0.25rem'>
          Key Insights
        </Text>
        <Text variant='body2'>
          High-potential opportunities across your worksites
        </Text>
      </InsightsHeader>

      {insights.map((insight, index) => {
        const isOpen = openStates[index] || false

        return (
          <AccordionCard
            key={index}
            setIsOpen={() => handleToggle(index)}
            isOpen={isOpen}
            mb='1rem'
          >
            <AccordionCardRow minHeight='4rem' allowHoverEffect={false}>
              <InsightHeader>
                <Text variant='action3'>{insight.title}</Text>
                <Text variant='body2'>{insight.subtitle}</Text>
              </InsightHeader>
            </AccordionCardRow>
            <AccordionCardRow allowHoverEffect={false}>
              <InsightContent>
                <InsightText variant='body2'>{insight.insight}</InsightText>
              </InsightContent>
            </AccordionCardRow>
          </AccordionCard>
        )
      })}
    </Box>
  )
}

export default AiInsights
